import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { pageTitle } from 'ember-page-title';
import type MarketSnapshotsOverviewController from 'lumen/controllers/market/snapshots/overview';
import contextualPageTitle from 'lumen/helpers/contextual-page-title';
import type MarketSnapshotsOverviewRoute from 'lumen/routes/market/snapshots/overview';
import type { ModelFrom } from 'lumen/utils/routes';

interface MarketSnapshotsOverviewSignature {
  Args: {
    controller: MarketSnapshotsOverviewController;
    model: ModelFrom<MarketSnapshotsOverviewRoute>;
  };
}

<template>
  {{pageTitle (contextualPageTitle (t "snapshots.view.overview"))}}

  <header class="sub-header sub-header--small">
    <div class="content-wrapper flex items-center">

    </div>
  </header>

  <div class="main-content-wrapper">
    <div class="content-wrapper main-content">
      <h2 class="text-neutral-emphasis">{{t "snapshots.view.overview"}}</h2>
    </div>
  </div>
</template> satisfies TOC<MarketSnapshotsOverviewSignature>;
